{
  "level1": [
    ["AT-07-01", "AT-07-02-01", "AT-07-02-02", "AT-07-07", "AT-07-08", "AT-07-10", "AT-07-11", "AT-07-12"],
    ["AT-07-03", "AT-07-04-01", "AT-07-04-02", "AT-07-05"],
    ["AT-07-06", "AT-07-17-01", "AT-07-17-02", "AT-07-18"],
    [
      "AT-07-09",
      "AT-07-13",
      "AT-07-14-01",
      "AT-07-14-02",
      "AT-07-14-03",
      "AT-07-14-04",
      "AT-07-14-05",
      "AT-07-15",
      "AT-07-16"
    ],
    ["AT-07-19", "AT-07-20", "AT-07-21", "AT-07-22", "AT-07-23-01", "AT-07-23-02", "AT-07-24"],
    ["AT-07-25", "AT-07-26-01", "AT-07-26-02", "AT-07-27", "AT-07-28", "AT-07-29-01", "AT-07-29-02", "AT-07-29-03"],
    [
      "AT-02-01-01",
      "AT-02-01-02-01",
      "AT-02-01-02-02",
      "AT-02-02",
      "AT-02-03-01-01",
      "AT-02-03-01-02",
      "AT-02-03-02",
      "AT-02-04-01",
      "AT-02-09"
    ],
    ["AT-02-05-01", "AT-02-05-02", "AT-02-06-01", "AT-02-06-02", "AT-02-07", "AT-02-08"],
    ["AT-02-04-02", "AT-02-10", "AT-02-11", "AT-02-12-01", "AT-02-12-02", "AT-02-13"],
    ["AT-02-14", "AT-02-15-01", "AT-02-15-02", "AT-02-16", "AT-02-17", "AT-02-18", "AT-02-19"],
    [
      "IT-32-BZ-01-01",
      "IT-32-BZ-01-02",
      "IT-32-BZ-02-01",
      "IT-32-BZ-02-02",
      "IT-32-BZ-03",
      "IT-32-BZ-04-01",
      "IT-32-BZ-04-02",
      "IT-32-BZ-05-01",
      "IT-32-BZ-05-02",
      "IT-32-BZ-05-03",
      "IT-32-BZ-06",
      "IT-32-BZ-07-01",
      "IT-32-BZ-07-02",
      "IT-32-BZ-11"
    ],
    ["IT-32-BZ-14", "IT-32-BZ-15"],
    [
      "IT-32-BZ-08-01",
      "IT-32-BZ-08-02",
      "IT-32-BZ-08-03",
      "IT-32-BZ-09",
      "IT-32-BZ-10",
      "IT-32-BZ-12",
      "IT-32-BZ-13",
      "IT-32-BZ-16",
      "IT-32-BZ-17",
      "IT-32-BZ-18-01",
      "IT-32-BZ-18-02",
      "IT-32-BZ-19",
      "IT-32-BZ-20"
    ],
    ["IT-32-TN-01", "IT-32-TN-02", "IT-32-TN-19", "IT-32-TN-20", "IT-32-TN-04", "IT-32-TN-05"],
    ["IT-32-TN-18", "IT-32-TN-12", "IT-32-TN-03", "IT-32-TN-11", "IT-32-TN-17", "IT-32-TN-15"],
    [
      "IT-32-TN-14",
      "IT-32-TN-06",
      "IT-32-TN-10",
      "IT-32-TN-21",
      "IT-32-TN-08",
      "IT-32-TN-07",
      "IT-32-TN-09",
      "IT-32-TN-16",
      "IT-32-TN-13"
    ],
    ["CH-1111", "CH-1121", "CH-1122", "CH-1211", "CH-1212", "CH-1213", "CH-1221"],
    ["CH-1112", "CH-1113", "CH-1222", "CH-1224", "CH-1226", "CH-1228", "CH-1231", "CH-1233", "CH-1241", "CH-1242"],
    [
      "CH-1114",
      "CH-1223",
      "CH-1225",
      "CH-1227",
      "CH-1232",
      "CH-1234",
      "CH-1243",
      "CH-1244",
      "CH-1245",
      "CH-1246",
      "CH-1247",
      "CH-1311",
      "CH-1312"
    ],
    ["CH-2111", "CH-2112", "CH-2121", "CH-2124", "CH-2131", "CH-2132", "CH-2133"],
    ["CH-2122", "CH-2123", "CH-2134", "CH-2211", "CH-2212", "CH-2221", "CH-2222", "CH-2223", "CH-2224"],
    ["CH-3111", "CH-3211", "CH-3221"],
    ["CH-3112", "CH-3113", "CH-3114", "CH-3222", "CH-3223", "CH-3224", "CH-3311"],
    ["CH-4111", "CH-4114", "CH-4121"],
    ["CH-4112", "CH-4113", "CH-4115", "CH-4116", "CH-4122", "CH-4123", "CH-4124", "CH-4125"],
    ["CH-4211", "CH-4213", "CH-4214", "CH-4215", "CH-4241", "CH-4243"],
    ["CH-4212", "CH-4221", "CH-4222", "CH-4223", "CH-4224", "CH-4225", "CH-4231", "CH-4232", "CH-4242", "CH-4244"],
    [
      "CH-6111",
      "CH-6112",
      "CH-6113",
      "CH-6114",
      "CH-6115",
      "CH-6121",
      "CH-6122",
      "CH-6131",
      "CH-6132",
      "CH-6211",
      "CH-6212"
    ],
    ["CH-5111", "CH-5112", "CH-5113", "CH-5121", "CH-5122", "CH-5123", "CH-5124"],
    [
      "CH-5211",
      "CH-5212",
      "CH-5214",
      "CH-5215",
      "CH-5216",
      "CH-5221",
      "CH-5222",
      "CH-5223",
      "CH-5231",
      "CH-5232",
      "CH-5233",
      "CH-5234"
    ],
    [
      "CH-7111",
      "CH-7112",
      "CH-7112",
      "CH-7113",
      "CH-7114",
      "CH-7115",
      "CH-7121",
      "CH-7123",
      "CH-7124",
      "CH-7125",
      "CH-7126",
      "CH-7211",
      "CH-7221",
      "CH-7222",
      "CH-7231"
    ],
    ["CH-8111", "CH-8112", "CH-8113", "CH-8114"],
    ["CH-8211", "CH-8212", "CH-8213", "CH-8214", "CH-8215", "CH-8221", "CH-8222", "CH-8224"]
  ],

  "level2": [
    [
      "AT-07-01",
      "AT-07-02-01",
      "AT-07-02-02",
      "AT-07-03",
      "AT-07-04-01",
      "AT-07-04-02",
      "AT-07-05",
      "AT-07-06",
      "AT-07-07",
      "AT-07-08",
      "AT-07-09",
      "AT-07-10",
      "AT-07-11",
      "AT-07-12",
      "AT-07-13",
      "AT-07-14-01",
      "AT-07-14-02",
      "AT-07-14-03",
      "AT-07-14-04",
      "AT-07-14-05",
      "AT-07-15",
      "AT-07-16",
      "AT-07-17-01",
      "AT-07-17-02",
      "AT-07-18",
      "AT-07-19",
      "AT-07-20",
      "AT-07-21",
      "AT-07-22",
      "AT-07-23-01",
      "AT-07-23-02",
      "AT-07-24",
      "AT-07-25",
      "AT-07-26-01",
      "AT-07-26-02",
      "AT-07-27",
      "AT-07-28",
      "AT-07-29-01",
      "AT-07-29-02",
      "AT-07-29-03"
    ],
    [
      "AT-02-01-01",
      "AT-02-01-02-01",
      "AT-02-01-02-02",
      "AT-02-02",
      "AT-02-03-01-01",
      "AT-02-03-01-02",
      "AT-02-03-02",
      "AT-02-04-01",
      "AT-02-04-02",
      "AT-02-05-01",
      "AT-02-05-02",
      "AT-02-06-01",
      "AT-02-06-02",
      "AT-02-07",
      "AT-02-08",
      "AT-02-09",
      "AT-02-10",
      "AT-02-11",
      "AT-02-12-01",
      "AT-02-12-02",
      "AT-02-13",
      "AT-02-14",
      "AT-02-15-01",
      "AT-02-15-02",
      "AT-02-16",
      "AT-02-17",
      "AT-02-18",
      "AT-02-19"
    ],
    [
      "IT-32-BZ-01-01",
      "IT-32-BZ-01-02",
      "IT-32-BZ-02-01",
      "IT-32-BZ-02-02",
      "IT-32-BZ-03",
      "IT-32-BZ-04-01",
      "IT-32-BZ-04-02",
      "IT-32-BZ-05-01",
      "IT-32-BZ-05-02",
      "IT-32-BZ-05-03",
      "IT-32-BZ-06",
      "IT-32-BZ-07-01",
      "IT-32-BZ-07-02",
      "IT-32-BZ-08-01",
      "IT-32-BZ-08-02",
      "IT-32-BZ-08-03",
      "IT-32-BZ-09",
      "IT-32-BZ-10",
      "IT-32-BZ-11",
      "IT-32-BZ-12",
      "IT-32-BZ-13",
      "IT-32-BZ-14",
      "IT-32-BZ-15",
      "IT-32-BZ-16",
      "IT-32-BZ-17",
      "IT-32-BZ-18-01",
      "IT-32-BZ-18-02",
      "IT-32-BZ-19",
      "IT-32-BZ-20"
    ],
    [
      "IT-32-TN-01",
      "IT-32-TN-02",
      "IT-32-TN-03",
      "IT-32-TN-04",
      "IT-32-TN-05",
      "IT-32-TN-06",
      "IT-32-TN-07",
      "IT-32-TN-08",
      "IT-32-TN-09",
      "IT-32-TN-10",
      "IT-32-TN-11",
      "IT-32-TN-12",
      "IT-32-TN-13",
      "IT-32-TN-14",
      "IT-32-TN-15",
      "IT-32-TN-16",
      "IT-32-TN-17",
      "IT-32-TN-18",
      "IT-32-TN-19",
      "IT-32-TN-20",
      "IT-32-TN-21"
    ],
    [
      "CH-1111",
      "CH-1121",
      "CH-1122",
      "CH-1211",
      "CH-1212",
      "CH-1213",
      "CH-1221",
      "CH-1112",
      "CH-1113",
      "CH-1222",
      "CH-1224",
      "CH-1226",
      "CH-1228",
      "CH-1231",
      "CH-1233",
      "CH-1241",
      "CH-1242",
      "CH-1114",
      "CH-1223",
      "CH-1225",
      "CH-1227",
      "CH-1232",
      "CH-1234",
      "CH-1243",
      "CH-1244",
      "CH-1245",
      "CH-1246",
      "CH-1247",
      "CH-1311",
      "CH-1312",
      "CH-2111",
      "CH-2112",
      "CH-2121",
      "CH-2124",
      "CH-2131",
      "CH-2132",
      "CH-2133",
      "CH-2122",
      "CH-2123",
      "CH-2134",
      "CH-2211",
      "CH-2212",
      "CH-2221",
      "CH-2222",
      "CH-2223",
      "CH-2224",
      "CH-3111",
      "CH-3211",
      "CH-3221",
      "CH-3112",
      "CH-3113",
      "CH-3114",
      "CH-3222",
      "CH-3223",
      "CH-3224",
      "CH-3311"
    ],
    [
      "CH-4111",
      "CH-4114",
      "CH-4121",
      "CH-4112",
      "CH-4113",
      "CH-4115",
      "CH-4116",
      "CH-4122",
      "CH-4123",
      "CH-4124",
      "CH-4125",
      "CH-4211",
      "CH-4213",
      "CH-4214",
      "CH-4215",
      "CH-4241",
      "CH-4243",
      "CH-4212",
      "CH-4221",
      "CH-4222",
      "CH-4223",
      "CH-4224",
      "CH-4225",
      "CH-4231",
      "CH-4232",
      "CH-4242",
      "CH-4244"
    ],
    [
      "CH-6111",
      "CH-6112",
      "CH-6113",
      "CH-6114",
      "CH-6115",
      "CH-6121",
      "CH-6122",
      "CH-6131",
      "CH-6132",
      "CH-6211",
      "CH-6212"
    ],
    [
      "CH-5111",
      "CH-5112",
      "CH-5113",
      "CH-5121",
      "CH-5122",
      "CH-5123",
      "CH-5124",
      "CH-5211",
      "CH-5212",
      "CH-5214",
      "CH-5215",
      "CH-5216",
      "CH-5221",
      "CH-5222",
      "CH-5223",
      "CH-5231",
      "CH-5232",
      "CH-5233",
      "CH-5234",
      "CH-7111",
      "CH-7112",
      "CH-7112",
      "CH-7113",
      "CH-7114",
      "CH-7115",
      "CH-7121",
      "CH-7123",
      "CH-7124",
      "CH-7125",
      "CH-7126",
      "CH-7211",
      "CH-7221",
      "CH-7222",
      "CH-7231"
    ],
    [
      "CH-8111",
      "CH-8112",
      "CH-8113",
      "CH-8114",
      "CH-8211",
      "CH-8212",
      "CH-8213",
      "CH-8214",
      "CH-8215",
      "CH-8221",
      "CH-8222",
      "CH-8224"
    ]
  ]
}
